import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/kanban/TopBar.css";
import { useWaUnread } from "../../hooks/useWaUnread";

export default function TopBar({
  theme,
  setTheme,
  onLogout,
  user,
  onBurgerClick,
  onPhoneClick,
}: {
  theme: "light" | "dark";
  setTheme: (t: "light" | "dark") => void;
  onLogout: () => void;
  user: any;
  onBurgerClick?: () => void;
  onPhoneClick?: () => void;
}) {
  const [openProfile, setOpenProfile] = useState(false);
  const [lang, setLang] = useState<"RU" | "KZ" | "EN">("RU");
  const navigate = useNavigate();
  const waUnread = useWaUnread();
  const menuRef = useRef<HTMLDivElement>(null);

  const fullName = `${user.lastName} ${user.firstName}`;
  const shortName = user.firstName || fullName;

  // число новых сообщений WhatsApp во вкладке браузера
  useEffect(() => {
    const base = document.title.replace(/^\(\d+\)\s*/, "");
    document.title = waUnread > 0 ? `(${waUnread}) ${base}` : base;
  }, [waUnread]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpenProfile(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        {/* Бургер — только на мобильном */}
        <button className="burger-btn-crm" onClick={onBurgerClick} aria-label="Menu">
          <span /><span /><span />
        </button>

        <div className="logo" style={{ display: "flex", alignItems: "center", gap: 8 }}><img src="/logo192.png" alt="" style={{ width: 28, height: 28, objectFit: "contain" }} />CRM</div>

        <div className="integrations topbar-integrations">
          <span>Интеграции</span>
          <span className="dot" />
          <span>Telegram</span>
          <span
            onClick={() => navigate("/whatsapp")}
            title={waUnread > 0 ? `Новых сообщений: ${waUnread}` : "WhatsApp"}
            style={{ cursor: "pointer", position: "relative" }}
          >
            WhatsApp
            {waUnread > 0 && (
              <span style={{ marginLeft: 6, background: "#25d366", color: "#fff", borderRadius: 10, fontSize: 11, fontWeight: 700, padding: "1px 7px" }}>
                {waUnread}
              </span>
            )}
          </span>
          <span>1C</span>
        </div>
      </div>

      <div className="topbar-right">
        {onPhoneClick && (
          <button
            onClick={onPhoneClick}
            title="Телефон (WebRTC)"
            style={{
              background: 'rgba(16,185,129,0.08)',
              border: '1px solid rgba(16,185,129,0.2)',
              borderRadius: 8,
              padding: '5px 10px',
              color: '#10b981',
              fontSize: 16,
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            📞
          </button>
        )}
        <button
          className="wa-topbar-btn"
          onClick={() => navigate("/whatsapp")}
          title={waUnread > 0 ? `Новых сообщений: ${waUnread}` : "WhatsApp"}
        >
          💬
          {waUnread > 0 && <span className="wa-topbar-badge">{waUnread}</span>}
        </button>
        <div className="lang-switch topbar-lang">
          {["RU", "KZ", "EN"].map((l) => (
            <button key={l} onClick={() => setLang(l as "RU" | "KZ" | "EN")} className={lang === l ? "active" : ""}>
              {l}
            </button>
          ))}
        </div>

        <div ref={menuRef} style={{ position: "relative" }}>
          <button
            onClick={() => setOpenProfile(!openProfile)}
            style={{
              background: "rgba(99,102,241,0.08)",
              border: "1px solid rgba(99,102,241,0.2)",
              borderRadius: 8,
              padding: "5px 12px",
              color: "#c7d2fe",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              maxWidth: 140,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            <span className="user-fullname">{fullName}</span>
            <span className="user-shortname">{shortName}</span>
            <span style={{ fontSize: 10, color: "#6366f1", marginTop: 1, flexShrink: 0 }}>▾</span>
          </button>

          {openProfile && (
            <div className="profile-menu">
              <button onClick={() => { navigate("/profile"); setOpenProfile(false); }}>
                Личный кабинет
              </button>
              <button onClick={() => { navigate("/settings"); setOpenProfile(false); }}>
                Настройки
              </button>
              <button className="logout" onClick={onLogout}>
                Выход
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
